import {createSlice} from "@reduxjs/toolkit";

const initialUserRoleRightsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  userRoleRightForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const userRoleRightsSlice = createSlice({
  name: "userRoleRights",
  initialState: initialUserRoleRightsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getUserRoleRightById
    userRoleRightFetched: (state, action) => {
      state.actionsLoading = false;
      state.userRoleRightForEdit = action.payload.userRoleRightForEdit;
      state.error = null;
    },
    // findUserRoleRights
    userRoleRightsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createUserRoleRight
    userRoleRightCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.userRoleRight);
    },
    // updateUserRoleRight
    userRoleRightUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.userRoleRightId === action.payload.userRoleRight.userRoleRightId) {
          return action.payload.userRoleRight;
        }
        return entity;
      });
    },
    // deleteUserRoleRight
    userRoleRightDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.userRoleRightId !== action.payload.userRoleRightId);
    },
    // deleteUserRoleRights
    userRoleRightsDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.userRoleRightId)
      );
    },
  }
});
